import { useTranslation } from "react-i18next";
import { Box, Text } from "@hawkins/components";
import { CheckboxFormControl, DatePickerDropdownFormControl, InputFormControl } from "@hawkins/forms";
import { Dimensions } from "@hawkins/variables";

import { TranslationNamespace } from "../../types";
import { useSession } from "../../hooks/useSessionContext";

export const Signature = () => {
  const { t } = useTranslation(TranslationNamespace.LEP);
  const { userInfo } = useSession();

  return (
    <>
      <CheckboxFormControl
        label={t("signature_label")}
        name="signatureAgreement"
        data-testid="signature-agreement-checkbox"
      />
      <Text
        component="ul"
        gutterBottom={Dimensions.Space16}
        gutterTop={Dimensions.Space16}
      >
        <Text component="li" gutterBottom={Dimensions.Space8}>{t('signature_desc')}</Text>
        <Text component="li">{t('signature_desc1')}</Text>
      </Text>
      <Box display="grid" gridTemplateColumns={"70% 30%"} paddingRight={Dimensions.Space8} columnGap={Dimensions.Space8}>
        <InputFormControl
          name={`signature`}
          label={t("stolen_section_d_title")}
          requirementType="required-star"
          fullWidth
          placeholder={`${userInfo?.givenName} ${userInfo?.familyName}`}
          data-testid="signature-input"
        />
        <DatePickerDropdownFormControl
          name="consentDate"
          label={t("emer_field2_label")}
          disabled
          data-testid="signature-date-picker"
        />
      </Box>
    </>
  );
};